import { ClinicUserGroupForm } from "../../../components/clinic-user-groups/ClinicUserGroupForm";
import { useClinicUserGroup } from "@/hooks/clinic-user-groups/useClinicUserGroup";
import { useNavigate } from "react-router-dom";

const AddClinicUserGroup = () => {
  const { createClinicUserGroup, loading } = useClinicUserGroup();
  const navigate = useNavigate();

  const handleSubmit = async (data: any) => {
    try {
      await createClinicUserGroup({
        groupName: data.groupName,
        stateId: data.stateId,
        clinicIds: data.clinicIds,
        userIds: data.assignedUsers.map((user: any) => user.id),
      });
      navigate("/admin/clinic-user-groups");
    } catch (error) {
      // Error handled in hook
    }
  };

  return (
    <ClinicUserGroupForm
      title="Add New Clinic User Group"
      onSubmit={handleSubmit}
      isSubmitting={loading}
    />
  );
};

export default AddClinicUserGroup;
